import { Component, Input } from '@angular/core';
import { SessionService } from '../../../Util/Session/session.service';
import { BackgroundVerificationService } from '../../../Model/BackgroundVerification/background-verification.service';
import { NgbActiveModal, NgbModal, NgbDropdownModule, NgbDatepickerModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { ConfirmationComponent } from '../.././../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-menual-bgvform',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, NgSelectModule, NgbDropdownModule, NgbDatepickerModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './menual-bgvform.component.html',
  styleUrl: './menual-bgvform.component.scss'
})
export class MenualBGVFormComponent {
  isDisabled: boolean = false;
  @Input() ESS_EmpBGVVerificationDetailsId: number = 0;
  @Input() EmpMasterId: number = 0;
  @Input() EmpTempCode: String = '';
  @Input() EmpName: String = '';
  @Input() JoiningDate: any = null;
  @Input() RegistrationDate: any = null;
  @Input() BirthDate: any = null;
  @Input() SetTypes: any = null;
  @Input() Today: any = null;
  @Input() ESS_BGVAPIMasterID: number = 0;
  @Input() VerificationType: any = null;
  @Input() VerificationTypeFinal: any = null;
  @Input() Verification_Status: any = null;
  @Input() Status_Description: any = null;
  @Input() Remarks: any = null;
  @Input() InitiatedOn: any = null;
  @Input() IsVerified: boolean = false;
  @Input() FileName: any = null;
  @Input() maxBirthdate: any = null;


  @Input() Datas = {
    LocalAddress1: null,//crc
    LocalAddress2: null,//crc
    FatherName: null,//crc
    BirthDate: null,//crc
    Type: 'current',
    Address1: null,//eav
    Address2: null,//eav
    PrevCompanyName: null,//ev
    PrevCompanyPosition: null,//ev
    PrevCompanyJoiningDate: null as any,//ev
    PrevCompanyRelievingDate: null as any,//ev
    EnrollmentNumber: null,//eqv
    College: null,//eqv
    QualificationName: null,//eqv
    UniversityBoard: null,//eqv
    CGPA: null,//eqv
  }

  FileNameURL = null as any;

  Vendors = [] as any;
  BgvStatus = [] as any;
  OverallBgvStatus = [] as any;
  VerificationTypes = [] as any;
  Details = {
    VerificationType: null as any,
    VerificationTypeFinal: null as any,
    APIRequest: null,
    SelectType: 'M',
    EmpMasterId: null as any,
    EmpTempCode: null as any,
    EmpName: null as any,
    ESS_BGVAPIMasterID: null as any,
    ESS_BGVFinalStatusID: null,
    FatherName: null,//crc
    BirthDate: null as any,//crc
    ESS_EmpBGVVerificationDetails_Manual: [{
      VerificationType: null,
      LocalAddress1: null,//crc
      LocalAddress2: null,//crc
      Type: 'current',
      Address1: null,//eav
      Address2: null,//eav
      PrevCompanyName: null,//ev
      PrevCompanyPosition: null,//ev
      PrevCompanyJoiningDate: null,//ev
      PrevCompanyRelievingDate: null,//ev
      EnrollmentNumber: null,//eqv
      College: null,//eqv
      QualificationName: null,//eqv
      UniversityBoard: null,//eqv
      CGPA: null,//eqv
      InitiatedOn: null,
      IsVerified: null,
      Verification_Status: null,
      Status_Description: null,
      Remarks: null,
      FileName: null,

    }] as any
  }
  user = [] as any;
  constructor(
    private backgroundVerification: BackgroundVerificationService,
    private activeModal: NgbActiveModal,
    protected common: CommonService,
    protected dateFormat: CustomDateParserFormatter,
    private toast: ToastService,
    private session: SessionService,
    private utility: UtilityService,
    private modalService: NgbModal,
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit() {
    this.ESS_BGVFillCombo('API');

    this.Details.ESS_EmpBGVVerificationDetails_Manual[0].LocalAddress1 = this.Datas.LocalAddress1;
    this.Details.ESS_EmpBGVVerificationDetails_Manual[0].LocalAddress2 = this.Datas.LocalAddress2;
    this.Details.FatherName = this.Datas.FatherName;
    this.Details.BirthDate = this.Datas.BirthDate;
    this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Address1 = this.Datas.Address1;
    this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Address2 = this.Datas.Address2;
    this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyName = this.Datas.PrevCompanyName;
    this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyPosition = this.Datas.PrevCompanyPosition;
    this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyJoiningDate = this.Datas.PrevCompanyJoiningDate;
    this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyRelievingDate = this.Datas.PrevCompanyRelievingDate;
    this.Details.ESS_EmpBGVVerificationDetails_Manual[0].EnrollmentNumber = this.Datas.EnrollmentNumber;
    this.Details.ESS_EmpBGVVerificationDetails_Manual[0].College = this.Datas.College;
    this.Details.ESS_EmpBGVVerificationDetails_Manual[0].QualificationName = this.Datas.QualificationName;
    this.Details.ESS_EmpBGVVerificationDetails_Manual[0].UniversityBoard = this.Datas.UniversityBoard;
    this.Details.ESS_EmpBGVVerificationDetails_Manual[0].CGPA = this.Datas.CGPA;
  }

  ngAfterViewInit() {
    if (this.ESS_BGVAPIMasterID > 0) {
      this.Details.ESS_BGVAPIMasterID = this.ESS_BGVAPIMasterID;
      this.ESS_BGVFillCombo('BS'); this.ESS_BGVFillCombo('VT', false);

      if (this.VerificationTypeFinal != null && this.VerificationTypeFinal != '') {
        this.Details.VerificationTypeFinal = this.VerificationTypeFinal;
      }

      if (this.Verification_Status != null && this.Verification_Status != '') {
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Verification_Status = this.Verification_Status;
      }

      if (this.Status_Description != null && this.Status_Description != '') {
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Status_Description = this.Status_Description;
      }

      if (this.Remarks != null && this.Remarks != '') {
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Remarks = this.Remarks;
      }

      if (this.InitiatedOn != null && this.InitiatedOn != '') {
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].InitiatedOn = this.dateFormat.parse(this.InitiatedOn);
      }

      if (this.IsVerified != null) {
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].IsVerified = this.IsVerified;
      }

      if (this.FileName != null && this.FileName != '') {
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].FileName = this.FileName;
        this.FileNameURL = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.MenualBGVAttachment + '/' + this.FileName;
      }

      if (this.Datas.PrevCompanyJoiningDate != null && this.Datas.PrevCompanyJoiningDate != '') {
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyJoiningDate = this.dateFormat.parse(this.Datas.PrevCompanyJoiningDate);
      }

      if (this.Datas.PrevCompanyRelievingDate != null && this.Datas.PrevCompanyRelievingDate != '') {
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyRelievingDate = this.dateFormat.parse(this.Datas.PrevCompanyRelievingDate);
      }

      if (this.Datas.BirthDate != null && this.Datas.BirthDate != '') {
        this.Details.BirthDate = this.dateFormat.parse(this.Datas.BirthDate);
      }

      this.Details.SelectType = 'MU';
    }
  }

  Validate(form: any) {
    if (form.valid) {
      this.Details.EmpMasterId = this.EmpMasterId;
      this.Details.EmpName = this.EmpName;
      this.Details.EmpTempCode = this.EmpTempCode;
      this.Details.ESS_EmpBGVVerificationDetails_Manual[0].VerificationType = this.Details.VerificationTypeFinal;
      if (this.Details.ESS_EmpBGVVerificationDetails_Manual[0].InitiatedOn != "" && this.Details.ESS_EmpBGVVerificationDetails_Manual[0].InitiatedOn != null) {
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].InitiatedOn = this.dateFormat.format(this.Details.ESS_EmpBGVVerificationDetails_Manual[0].InitiatedOn);
      }

      if (this.common.ToLowerCase(this.Details.VerificationTypeFinal) == 'crc') {
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Type = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Address1 = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Address2 = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyName = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyPosition = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyJoiningDate = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyRelievingDate = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].EnrollmentNumber = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].College = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].QualificationName = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].UniversityBoard = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].CGPA = null;
      } else if (this.common.ToLowerCase(this.Details.VerificationTypeFinal) == 'eav') {
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].LocalAddress1 = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].LocalAddress2 = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Type = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyName = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyPosition = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyJoiningDate = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyRelievingDate = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].EnrollmentNumber = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].College = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].QualificationName = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].UniversityBoard = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].CGPA = null;
      } else if (this.common.ToLowerCase(this.Details.VerificationTypeFinal) == 'ev') {
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].LocalAddress1 = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].LocalAddress2 = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Type = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Address1 = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Address2 = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].EnrollmentNumber = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].College = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].QualificationName = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].UniversityBoard = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].CGPA = null;

        if (this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyJoiningDate != "" && this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyJoiningDate != null) {
          this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyJoiningDate = this.dateFormat.format(this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyJoiningDate);
        }
        if (this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyRelievingDate != "" && this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyRelievingDate != null) {
          this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyRelievingDate = this.dateFormat.format(this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyRelievingDate);
        }
      } else if (this.common.ToLowerCase(this.Details.VerificationTypeFinal) == 'eqv') {
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].LocalAddress1 = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].LocalAddress2 = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Type = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Address1 = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Address2 = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyName = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyPosition = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyJoiningDate = null;
        this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyRelievingDate = null;
      }

      this.ESS_EmpBGVManualVerificationDetailsInsert();
    } else {
      form.submitted = true;
    }
  }

  ESS_EmpBGVManualVerificationDetailsInsert() {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then((result: any) => {
      if (result) {
        this.isDisabled = true;

        if (this.Details.BirthDate != null && this.Details.BirthDate != '') {
          this.Details.BirthDate = this.dateFormat.format(this.Details.BirthDate);
        }

        this.backgroundVerification.ESS_EmpBGVManualVerificationDetailsInsert(this.Details).subscribe({
          next: (response) => {
            if (response.Error_Code == '01') {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.close(true);
                }
              });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });

      }
    });
  }

  ESS_BGVFillCombo(SelectType: string, IsClear = true) {
    if (SelectType == 'API') {
      this.Vendors = [];
    } else if (SelectType == 'BS') {
      this.BgvStatus = [];
      this.OverallBgvStatus = [];
    } else if (SelectType == 'VT') {
      this.VerificationTypes = [];
    }

    this.isDisabled = true;
    this.backgroundVerification.ESS_BGVFillCombo({ SelectType: SelectType, ESS_BGVCheckListMasterID: 0, ESS_BGVApiMasterID: this.Details.ESS_BGVAPIMasterID, Id: this.Details.ESS_BGVAPIMasterID }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (SelectType == 'API') {
            this.Vendors = response.Table;
          } else if (SelectType == 'BS') {
            this.BgvStatus = response.Table;
            this.OverallBgvStatus = response.Table;

            const index = this.SetTypes.findIndex((e: any) => e.ESS_BGVAPIMasterID == this.Details.ESS_BGVAPIMasterID);
            if (index >= 0) {
              this.Details.VerificationType = this.SetTypes[index].VerificationType;
            }

          } else if (SelectType == 'VT') {
            this.VerificationTypes = response.Table;
            if (IsClear) {
              this.Details.VerificationTypeFinal = null;
            }

          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  upload(event: any, Folder: any, Tag = '') {
    try {
      if ((event.currentTarget.accept).includes(event.target.files[0].type.split('/')[1])) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.UploadServices(Folder, reader.result, Tag, null, event.target.files[0].type.split('/')[1]);
          event.target.value = null;
        };
      } else {
        this.toast.show({ message: 'selected file not allow, allow file only ' + event.currentTarget.accept, type: toastTypeEnum.danger });
        event.target.value = null;
      }
    } catch (e) { }
  }

  UploadServices(Folder: string, Base64: any, Tag = '', index = null, type = '') {
    this.isDisabled = true;
    this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': Base64 }).subscribe((response: any) => {
      if (response.FileName != "") {
        if (Folder == this.common.CompanyParameterValue.MenualBGVAttachment && Tag == '') {
          this.Details.ESS_EmpBGVVerificationDetails_Manual[0].FileName = response.FileName;
          this.FileNameURL = response.Url;
        }
      } else {
        this.toast.show({ message: 'Image not uploaded', type: toastTypeEnum.warning });
      }
      this.isDisabled = false;
    }, (error) => {
      this.isDisabled = false;
    });
  }

  RemoveAttachment() {
    if (this.ESS_BGVAPIMasterID == 0) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to remove attachment?';
      modalRef.result.then((result: any) => {
        if (result) {
          this.FileNameURL = null;
          this.Details.ESS_EmpBGVVerificationDetails_Manual[0].FileName = null
        }
      });
    }
  }

  changeFinalstausConfirmation() {
    if (this.Details.VerificationType != null) {
      const index = this.SetTypes.findIndex((e: any) => e.ESS_BGVAPIMasterID == this.Details.ESS_BGVAPIMasterID);
      if (index >= 0) {
        const modalRef = this.modalService.open(ConfirmationComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = 'Do you want to change.?';
        modalRef.componentInstance.Message2 = 'When the overall status is changed, all existing entries are updated accordingly.?';
        modalRef.componentInstance.Button1 = 'Yes';
        modalRef.componentInstance.Button2 = 'No';
        modalRef.result.then((result: any) => {
          if (!result) {
            this.Details.VerificationType = this.SetTypes[index].VerificationType;
          }
        });
      }
    }
  }

  getLowestDateVariable(): any {
    const dateVariables = [
      { name: 'Today', date: this.Today },
      { name: 'RegistrationDate', date: this.RegistrationDate },
      { name: 'JoiningDate', date: this.JoiningDate }
    ];

    const lowest = dateVariables.filter(e => (e.date != null && e.date != '')).reduce((lowest, current) => {
      const currentDate = current.date;
      const lowestDate = lowest.date;

      if (currentDate.year < lowestDate.year) return current;
      if (currentDate.year > lowestDate.year) return lowest;

      if (currentDate.month < lowestDate.month) return current;
      if (currentDate.month > lowestDate.month) return lowest;

      if (currentDate.day < lowestDate.day) return current;

      return lowest; // Return the object, not lowest.date
    });

    // Convert {day, month, year} to Date object for [minDate]
    if (lowest.name == 'RegistrationDate') {
      return this.RegistrationDate;
    } else if (lowest.name == 'JoiningDate') {
      return this.JoiningDate;
    } else {
      return this.Today;
    }
  }

  close(flag = false) {
    this.activeModal.close(flag);
  }
}
